import React from 'react';
import {
	SimpleForm,
	TextInput,
	BooleanInput,
	SelectInput,
	ArrayInput,
	SimpleFormIterator,
	ReferenceInput,
	AutocompleteInput,
} from 'react-admin';
import { Box } from '@mui/material';

import Create from '../common/views/Create';

const customerOptionText = choice => {
	return choice.name ? choice.name : '';
}

const ContactCreate = props => (
	<Create {...props}>
		<SimpleForm redirect="list">
			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<TextInput
					source="first_name"
					label="First Name"
					validate={(value) => (!value ? 'First name is required' : undefined)}
					fullWidth
				/>
				<TextInput
					source="last_name"
					label="Last Name"
					validate={(value) => (!value ? 'Last name is required' : undefined)}
					fullWidth
				/>
			</Box>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<TextInput
					source="email"
					label="Email"
					type="email"
					fullWidth
				/>
				<TextInput source="phone" label="Phone" fullWidth />
			</Box>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<TextInput source="mobile" label="Mobile" fullWidth />
				<TextInput source="company" fullWidth />
			</Box>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<TextInput source="job_title" label="Job Title" fullWidth />
				<TextInput source="department" fullWidth />
			</Box>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<SelectInput
					source="contact_type"
					label="Contact Type"
					choices={[
						{ id: 'general', name: 'General' },
						{ id: 'lead', name: 'Lead' },
						{ id: 'prospect', name: 'Prospect' },
						{ id: 'customer', name: 'Customer' },
						{ id: 'churned', name: 'Churned' },
						{ id: 'partner', name: 'Partner' },
					]}
				/>
				<SelectInput
					source="status"
					choices={[
						{ id: 'active', name: 'Active' },
						{ id: 'inactive', name: 'Inactive' },
					]}
				/>
			</Box>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
				<TextInput source="source" fullWidth />
				<BooleanInput source="marketing_consent" defaultValue={true} />
			</Box>

			<ReferenceInput label="Customer" source="customer_id" reference="customers">
				<AutocompleteInput optionText={customerOptionText} />
			</ReferenceInput>

			<TextInput source="notes" fullWidth multiline rows={4} />

			<ArrayInput source="tags">
				<SimpleFormIterator>
					<TextInput source="" />
				</SimpleFormIterator>
			</ArrayInput>
		</SimpleForm>
	</Create>
);

export default ContactCreate;